import { STANDARD_DUEL_RULES, type DuelRules } from "@mk/shared";

const KEY_PREFIX = "mk:friendly-duel-rules:";

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function standardRules(): DuelRules {
  return { ...STANDARD_DUEL_RULES };
}

function isDuelRules(value: unknown): value is DuelRules {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const candidate = value as Record<string, unknown>;
  if (Object.keys(candidate).length !== 4) return false;
  return (
    [1, 2, 3].includes(candidate.durationMinutes as number) &&
    [4, 5, 6].includes(candidate.maxAttempts as number) &&
    (candidate.victoryRule === "fewest-attempts" ||
      candidate.victoryRule === "first-to-solve") &&
    typeof candidate.pressureEnabled === "boolean"
  );
}

function deviceStorage(): StorageLike | null {
  return typeof window === "undefined" ? null : window.localStorage;
}

/** Bu hesaptan en son seçilen arkadaş maçı kurallarını güvenli biçimde okur. */
export function loadFriendlyDuelRules(
  userId: string | undefined,
  storage: StorageLike | null = deviceStorage(),
): DuelRules {
  if (!userId || !storage) return standardRules();
  try {
    const raw = storage.getItem(`${KEY_PREFIX}${userId}`);
    if (!raw) return standardRules();
    const parsed: unknown = JSON.parse(raw);
    return isDuelRules(parsed) ? { ...parsed } : standardRules();
  } catch {
    return standardRules();
  }
}

/** Seçim değiştikçe kaydeder; depolama engelliyse ekran davranışını bozmaz. */
export function saveFriendlyDuelRules(
  userId: string | undefined,
  rules: DuelRules,
  storage: StorageLike | null = deviceStorage(),
): void {
  if (!userId || !storage) return;
  try {
    storage.setItem(`${KEY_PREFIX}${userId}`, JSON.stringify(rules));
  } catch {
    // Gizli sekme/kota gibi depolama hataları maç kurulumunu engellememeli.
  }
}
